/**
 * Баннер мини-опроса (banner-line-survey.vue), который выводится в layout-main над шапкой на всех страницах.
 * Показ выводится из store и роута, поэтому layout, шапка, главная и сам баннер всегда согласованы.
 *
 * - на главной баннер показывается всегда, кнопка закрытия скрывает его до ухода с главной;
 * - на внутренних страницах баннер можно закрыть навсегда (localStorage).
 */

export const SURVEY_POLL_CODE = 'poll-what-kind-of-candy-are-you-today';
export const SURVEY_CLOSED_STORAGE_KEY = 'isBannerLineSurveyClosed';

export default {
  computed: {
    isHomePage() {
      return this.$route.meta.api === 'HomeController';
    },
    // state.response.page перетирается ответом каждой страницы, опрос с внутренних страниц дублируется в state.page.PollController
    poll() {
      return this.$store.state.response?.page?.PollController?.poll
          || this.$store.state.page?.PollController?.poll
          || this.$store.state.page?.HomeController?.poll;
    },
    isSurveyBannerShown() {
      if (this.poll?.CODE !== SURVEY_POLL_CODE) return false;
      if (this.isHomePage) return !this.$store.state.isSurveyBannerHidden;
      return !this.$store.state.isSurveyBannerClosed;
    },
  },
};
